/**
 * @file getSelectedAnswer.ts
 * Exports a method that for returning an array of selected answers.
 */
import type { AppState } from '../types';
import { prop } from 'ramda';

/**
 * Helper method that returns an array of selected answers.
 *
 * Currently all questions are organized in a JSON file. In the future this data
 * may come from an external API.
 *
 * @param {AppState} appState
 *   The state object shared across the application.
 *
 * @returns {array}
 *   An array of Question Data objects.
 */

type ansProps = {
  id: string;
  state: string;
  answer: string;
};

export default (appState: AppState): ansProps[] => {
  // Get an array of all currently submitted answers that have a truthy value.
  const submitted = prop('submitted')(appState);
  const {
    appData: { questions },
  } = appState;
  type LookupProps = {
    [key: string]: string;
  };

  const testNameLookup = questions.reduce(
    (lookup: LookupProps, testItem: { id: string; state: string }) => {
      const { id, state } = testItem;
      lookup[id] = state;
      return lookup;
    },
    {},
  );

  const result = Object.entries(submitted).map(([key, value]) => {
    return {
      state: testNameLookup[key],
      answer: Object.values(value as string)[0],
      id: key,
    };
  });

  return result;
};
